import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../styles/Landing.css';

const Landing: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>AI Nutrition - Smart Meal Planning for Better Health</title>
        <meta name="description" content="AI-powered meal planning and nutrition analysis to help you eat healthier, save time, and reach your health goals." />
      </Helmet>

      <div className="landing-page">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1>Smart Nutrition Planning Powered by AI</h1>
              <p>Personalised meal plans and recipe suggestions tailored to your health goals and dietary preferences.</p>
              <div className="hero-buttons">
                <Link to="/recipes-by-ingredients" className="button button-primary">Find Recipes</Link>
                <Link to="/signup" className="button button-outline">Get Started</Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="image-placeholder">
                <img src="/landingpage.jpg" alt="Healthy meal with fresh vegetables and balanced nutrition" className="hero-img" />
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2 className="section-title">Why Choose AI Nutrition?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                    <path d="M9 14l2 2 4-4"></path>
                  </svg>
                </div>
                <h3>Smart Meal Planning</h3>
                <p>Generate Personalised meal plans based on your dietary preferences, restrictions, and nutritional goals.</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 22h14"></path>
                    <path d="M5 2h14"></path>
                    <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22"></path>
                    <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"></path>
                  </svg>
                </div>
                <h3>Nutrition Analysis</h3>
                <p>Get detailed nutritional information for any meal, including calories and macronutrients</p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"></path>
                    <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"></path>
                  </svg>
                </div>
                <h3>Recipe Discovery</h3>
                <p>Find delicious recipes based on ingredients you already have, reducing food waste and grocery expenses.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <h2 className="section-title">What Our Users Say</h2>
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"AI Nutrition has completely transformed how I plan my meals. I've saved time, money, and I'm eating healthier than ever!"</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-avatar"></div>
                  <div className="author-info">
                    <h4>Sarah Johnson</h4>
                    <p>Fitness Enthusiast</p>
                  </div>
                </div>
              </div>
              
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>"As someone with multiple food allergies, finding suitable recipes was always a challenge. This app makes it so easy!"</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-avatar"></div>
                  <div className="author-info">
                    <h4>Michael Chen</h4>
                    <p>Food Allergy Advocate</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <h2>Ready to Transform Your Nutrition?</h2>
            <p>Join thousands of users who have improved their health with AI-powered meal planning.</p>
            <div className="cta-buttons">
              <Link to="/signup" className="button button-secondary button-lg">Create Free Account</Link>
              <Link to="/recipes-by-ingredients" className="button button-outline button-lg">Explore Recipes</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Landing; 